import { httpClient, ApiResponse } from '@/utils';
import { IGetStoresDTO, StoresEndpoints, IStoreResponse } from '@/models/stores.model';

class StoresAPI {
  static getStores(data: IGetStoresDTO): ApiResponse<IStoreResponse> {
    return httpClient.get<IStoreResponse>(StoresEndpoints.STORES, { params: data });
  }
}

export default StoresAPI;
